<div mat-dialog-title>
  <span>{{ 'GRID_VIEWS.DELETE_TITLE' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>
<!--TODO: add error support-->

<mat-dialog-content>
  <q9-section>
    <div content>
      {{ 'GRID_VIEWS.DELETE_MESSAGE' | translate: view }}
    </div>
  </q9-section>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <q9-secondary-button color="warn" tabindex="2" mat-dialog-close>
    {{ 'GENERAL.CANCEL' | translate }}
  </q9-secondary-button>
  <q9-primary-button color="warn" tabindex="1" (click)="onSubmit()" [isLoading]="isSubmitted">
    {{ 'GENERAL.DELETE' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
